module.exports = __webpack_public_path__ + "img/华侨报刊大系封底.99b42ae1.jpg";